import { Component, EventEmitter, inject, OnDestroy, Output } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { TooltipModule } from "primeng/tooltip";
import { Subject, takeUntil } from "rxjs";
import {
  FileContentListComponent,
  FileInfo,
} from "src/app/common/components/file-content-list/file-content-list.component";

@Component({
  selector: "app-add-files-popup",
  standalone: true,
  imports: [ButtonModule, TooltipModule],
  templateUrl: "./add-files-popup.component.html",
  styleUrl: "./add-files-popup.component.scss",
})
export class AddFilesPopupComponent implements OnDestroy {
  private readonly dialogService = inject(DialogService);
  private readonly destroySubject = new Subject<void>();

  @Output() readonly filesSelected = new EventEmitter<FileInfo[]>();

  uploadedFilesListRef: DynamicDialogRef | undefined;

  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }

  openDialogToAddFiles(): void {
    this.uploadedFilesListRef = this.dialogService.open(FileContentListComponent, {
      header: $localize`:@@prompt_add_file_to_prompt:Ajouter des fichiers au prompt`,
      width: "70%",
      data: {
        selectionMode: true,
      },
    });
    this.uploadedFilesListRef.onClose.pipe(takeUntil(this.destroySubject)).subscribe((selectedFiles: FileInfo[]) => {
      if (selectedFiles) {
        this.filesSelected.emit(selectedFiles);
      }
    });
  }
}
